import React  from 'react';
import {FieldViewProps} from "../../../../render/view";

export default function FieldTimeSpent_View(props:FieldViewProps) {

    const value = _.get(props.model, props.field.fieldId, null)

    if (_.isNil(value)) return false;

    return (
        <div className={Classes("ui5-txt-default", "fl-ac", props.className)}>
            <span className="txt-truncate">{gd.utils.minutesHumanize(value)}</span>
        </div>
    );
}
